import { INSPECTION_STATUS } from '@/_legacy/constants';

/**
 * Filter by status (list) (0 - Open, 10 - Solved, 20 - In progress, 30 - Can't do).
 */
export enum IssueStatus {
  Pending = 0,
  Done = 10,
  InProgress = 20,
  CantDo = 30,
}

export enum InspectionStatus {
  Empty = INSPECTION_STATUS.EMPTY,
  Done = INSPECTION_STATUS.DONE,
  Archived = INSPECTION_STATUS.ARCHIVED,
  CantDo = INSPECTION_STATUS.CANT_DO,
  Draft = INSPECTION_STATUS.DRAFT,
}

/**
 * Filter by status: (0 - Open, 10 - In progress, 20 - Done).
 */
export enum Status {
  Pending = 0,
  InProgress = 10,
  Done = 20,
  CantDo = 30,
  SystemRejected = 50,
}

export enum Type {
  Issue = 0,
  Inspection = 10,
}

export function statusToIssueStatus(status: Status): IssueStatus {
  switch (status) {
    case Status.Done:
      return IssueStatus.Done;
    case Status.InProgress:
      return IssueStatus.InProgress;
    case Status.Pending:
      return IssueStatus.Pending;
    default:
      throw Error(`Invalid status: ${status}`);
  }
}
